/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */

import {
	ListType,
	DecisionMakingServiceReadyEvent,
	RenderCardsCommand
} from '@studyportals/decision-making-service-interfaces';
import { ISubscriber } from '@studyportals/event-aggregation-service-interface';
import { Drawer, DrawerMode } from '@studyportals/drawer';
import { AuthenticationCompletedEvent } from '@studyportals/authentication-service-interfaces';

class DecisionMakingService implements ISubscriber<DecisionMakingServiceReadyEvent> {
	public drawer: HTMLElement | null = null;
	public drawerContent: HTMLElement | null = null;
	public drawerTitle: HTMLElement | null = null;
	public closeButton: HTMLElement | null = null;
	public wishlistWrapper: HTMLElement | null = null;
	public authServiceWrapper: HTMLElement | null = null;
	public loadedIndependently = false;
	public readonly drawerComponent: Drawer;
	public itIsAlreadyInitd = false;

	constructor() {
		this.drawer = this.getDrawerContent('#drawer');
		this.drawerTitle = this.getDrawerHeader('drawerHeader');
		this.wishlistWrapper = this.drawer?.querySelector('.WishlistWrapper') ?? null;
		this.authServiceWrapper = this.drawerContent?.querySelector('.AuthServiceWrapper') ?? null;
		this.drawerComponent = new Drawer({
			mode: DrawerMode.RIGHT,
			content: this.drawer,
			header: this.drawerTitle,
			canBeClosed: true,
			onClose: (): void => {
				document.dispatchEvent(new Event('closeWishlistDrawer'));
			}
		});

		this.attachListeners();
	}

	private getDrawerContent(mode: string): HTMLElement {
		const content = document.querySelector(mode) as HTMLElement;
		content.remove();

		return content;
	}

	private getDrawerHeader(mode: string): HTMLElement {
		const header = document.getElementById(mode) as HTMLElement;
		header.remove();

		return header;
	}

	public init(): void {
		window.EventAggregationService.subscribeTo(DecisionMakingServiceReadyEvent.EventType, this, true);
	}

	public notify(event: DecisionMakingServiceReadyEvent): void | Promise<void> {
		const placeholderElement = document.getElementById('DecisionMakingServicePlaceholderDrawer');

		if (!placeholderElement) {
			console.error('Could not find placeholder element for DecisionMakingServiceDrawer');
			return;
		}

		const command = new RenderCardsCommand('id', ListType.WISHLIST, placeholderElement);
		event.decisionMakingServiceApplication.renderCards(command);
	}

	public attachListeners(): void {
		document.addEventListener('openWishlistDrawer', this.openDrawer.bind(this));
		document.addEventListener('closeWishlistDrawer', this.closeDrawer.bind(this));

		document.addEventListener('show_auth_service_in_wishlist', () => this.triggerAuthenticationService.bind(this));

		this.closeButton?.addEventListener('click', () => {
			document.dispatchEvent(new Event('closeWishlistDrawer'));
		});

		this.drawer?.addEventListener('click', (event) => {
			if (this.drawer !== event.target) return;
			document.dispatchEvent(new Event('closeWishlistDrawer'));
		});
	}

	public openDrawer(): void {
		this.drawerComponent.open();

		if (!this.itIsAlreadyInitd) {
			this.init();
			this.itIsAlreadyInitd = true;
		}

		document.dispatchEvent(new Event('onWishlistOpen'));
	}

	public closeDrawer(): void {
		this.switchMode('Wishlist');

		this.drawer?.classList.remove('Animate');
		document.body.removeAttribute('data-wishlist-drawer');
		setTimeout(() => {
			this.drawer?.classList.remove('Opened');
		}, 400);
	}

	public switchMode(mode: string): void {
		switch (mode) {
		case 'Wishlist':
			this.wishlistMode();
			break;
		case 'Register':
			this.registerMode();
			break;
		default:
			this.registerMode();
		}
	}

	public wishlistMode(): void {
		this.drawerComponent?.switchMode(DrawerMode.RIGHT);

		if (this.drawerTitle) {
			this.drawerTitle.innerText = 'Wishlist';
		}

		this.authServiceWrapper?.classList.add('Hidden');
		this.wishlistWrapper?.classList.remove('Hidden');
	}

	public registerMode(): void {
		this.authServiceWrapper?.classList.remove('Hidden');
		this.wishlistWrapper?.classList.add('Hidden');
	}

	public async triggerAuthenticationService(): Promise<void> {
		const loggedInStatus = sessionStorage.getItem('LoggedInStatus');

		if (loggedInStatus !== 'true') {
			//Load the AuthenticationService and fire an event when it's done
			const servicePlaceholder = this.authServiceWrapper?.querySelector('.AuthPlaceholder');
			const serviceURL = servicePlaceholder?.getAttribute('data-service-url');

			if (!serviceURL) return;
			await window['Loot'].MicroserviceInjector.injectScriptToBody(serviceURL);

			window.dispatchEvent(
				new CustomEvent('ShowAuth', {
					detail: {
						incentive: 'Wishlist'
					}
				})
			);

			this.switchMode('Register');

			if (typeof window['EventAggregationService'] === 'undefined') {
				return;
			}

			window['EventAggregationService'].subscribeTo(AuthenticationCompletedEvent.EventType, {
				notify: () => {
					this.switchMode('Wishlist');
				}
			});
		}
	}
}

window.addEventListener('DOMContentLoaded', () => {
	new DecisionMakingService();
});
